import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { GridRow } from 'dibs-elements/exports/Grid';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

import { HpRespModuleContainer } from '../HpRespModuleContainer/HpRespModuleContainer';
import HpRespShopByModuleItem from './HpRespShopByModuleItem';
import { trackShopByItemsImpressions, trackShopByItemClick } from '../helpers/shopByTracking';
import { trackModuleLocation } from '../helpers/moduleLocationTracking';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

export const handleInitialDisplay = ({ inViewport, items }) => {
    if (items && inViewport) {
        trackShopByItemsImpressions(items);
    }
};

export const HpRespShopByModuleComponent = ({
    componentModule,
    useLazyLoadImages,
    moduleIndex,
    totalModules,
}) => {
    if (!componentModule) {
        return null;
    }

    const { items = [], title } = componentModule;

    return (
        <HpRespModuleContainer addTopGap>
            <PageLayout setViewportBackground="sassyColorWhite">
                <HpRespModuleContainer.Header title={title} />
                <SharedInViewport
                    stopWhenInViewport
                    onInViewportChange={({ inViewport }) =>
                        handleInitialDisplay({ inViewport, items })
                    }
                >
                    <GridRow>
                        {items.map((item, index) => {
                            return (
                                <HpRespShopByModuleItem
                                    key={`${item?.linkData?.path}-${index}`}
                                    item={item}
                                    onClick={() => {
                                        trackShopByItemClick(item, index);
                                        trackModuleLocation({
                                            label: 'eight block module',
                                            moduleIndex,
                                            totalModules,
                                        });
                                    }}
                                    useLazyLoadImages={useLazyLoadImages}
                                />
                            );
                        })}
                    </GridRow>
                </SharedInViewport>
            </PageLayout>
        </HpRespModuleContainer>
    );
};

HpRespShopByModuleComponent.propTypes = {
    componentModule: PropTypes.object.isRequired,
    useLazyLoadImages: PropTypes.bool,
    moduleIndex: PropTypes.number,
    totalModules: PropTypes.number,
};

export const HpRespShopByModule = createFragmentContainer(HpRespShopByModuleComponent, {
    componentModule: graphql`
        fragment HpRespShopByModule_componentModule on ShopByModule {
            title
            items {
                cmsId
                linkData {
                    # shopByTracking.js
                    path
                }
                ...HpRespShopByModuleItem_item
            }
        }
    `,
});
